/* eslint-disable react/prop-types */
import { h, Fragment } from 'preact';

const ATCButton = ({ dispatch, state }) => {
  if (state.activeVariant.available) {
    return (
      <Fragment>
        {state.hasAddedToCart && (
          <div className="two-split">
            <a className="btn" href="/cart">
              Checkout
            </a>
            <a className="btn btn--secondary" href="/pages/menu">
              View Menu
            </a>
          </div>
        )}
        <button
          className="btn product-form__cart-submit"
          onClick={() => {
            dispatch({
              type: 'ADD_TO_CART',
            });
          }}
          disabled={state.hasAddedToCart}
        >
          {!state.hasAddedToCart ? (
            <span>${state.itemTotal} | Add to cart</span>
          ) : (
            <span>Item added to cart!</span>
          )}
        </button>
      </Fragment>
    );
  } else {
    return (
      <button className="btn product-form__cart-submit" disabled>
        Item Unavailable
      </button>
    );
  }
};

export default ATCButton;
